import { Box, Text } from '@bechtel/gds';
//@ts-ignore images ignore
import { ReactComponent as BechtelOriginalVariantLogo } from '~/images/bechtel-logo-original-variant.svg';
export const CopyRightsContent = () => {
  const d = new Date();
  const year = d.getFullYear();
  return (
    <Box flexDirection={{ sm: 'column' }} pb={{ sm: '400' }} alignItems={{ sm: 'center' }}>
      <Box mb={{ sm: '300' }} style={{ width: '100%' }}>
        <BechtelOriginalVariantLogo />
      </Box>
      <Box p={{ sm: '200' }}>
        <Text
          color="white"
          size={200}
          family="openSansCondensed"
          weight={400}
          style={{ opacity: '0.7', lineHeight: '11px' }}
        >
          © 1984 - {year} <br />
          Bechtel Corp
        </Text>
      </Box>
    </Box>
  );
};
